<template>
  <div v-if="s1" v-bind:class="sGetConfig('chkMenuFontSizeLarge') ? 'fx12' : ''">
    <van-swipe-cell>
      <van-grid :center="false" clickable :column-num="1">
        <van-grid-item>
          <van-row>
            <van-col span="2" @click="onClick">
              <div class="qty C1">{{ s1.Qty }}</div>
            </van-col>
            <van-col span="15" @click="onClick">
              <div class="s1">
                {{ s1.DispName }}
                <span class="note" v-if="s1.Notes.length">{{ s1.Notes.join("/") }}</span>
              </div>
            </van-col>
            <van-col span="5" align="right" @click="onClick">
              <LabelAmt :amt="s1.Amt" />
            </van-col>
            <van-col span="2" align="right">
              <!-- <van-button
                square
                type="danger"
                icon="delete-o"
                text="删除"
                @click="onDelete"
              /> -->
              <van-icon name="delete-o" color="#ee0a24" size="1.6em" @click="onDelete" />
            </van-col>
          </van-row>
          <van-row
            v-for="(r, index) in rst.filter((r) => r.Parent == s1.rno)"
            :key="index + ':' + r.Parent"
            @click="onClick"
          >
            <van-col span="2"></van-col>
            <van-col span="15">
              <div>
                {{ r.DispName }}
                <span class="note" v-if="r.Notes.length">{{ r.Notes.join("/") }}</span>
                x<span class="C1"> {{ r.Qty }}</span>
              </div>
            </van-col>
            <van-col span="5" align="right">
              <LabelAmt :amt="r.Amt" />
            </van-col>
            <van-col span="2"></van-col>
          </van-row>
        </van-grid-item>
      </van-grid>
      <template #right>
        <van-button square type="danger" icon="delete-o" text="删除" @click="onDelete" />
      </template>
    </van-swipe-cell>
  </div>
</template>
<style scoped>
.van-button {
  height: 100%;
  background-color: #f56c6c;
}
.van-row {
  line-height: 1.8rem;
}

.s1 {
  font-weight: bold;
  /* font-size: 1rem; */
}
.qty {
  width: 1.5rem;
  line-height: 1.5rem;
  /* background: #333; */
  /* color: white; */
  font-size: 1.2rem;
  text-align: center;
  font-weight: bold;
}
</style>

<script>
import LabelAmt from "./element/LableAmt.vue";
export default {
  name: "CarItem",
  components: {
    LabelAmt,
  },
  props: {
    s1: Object,
    rst: Array,
  },
  data() {
    return {};
  },
  methods: {
    onClick() {
      this.$emit("click");
    },
    onDelete() {
      this.gSure("確認刪除項目")
        .then(() => {
          // this.gMsg("Y");
          this.$emit("del", this.s1);
        })
        .catch(() => {
          // this.gMsg("N");
        });
    },
  },
};
</script>
